// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"

export default class LabeledValue extends Component {
  props: {
    label: string,

    const?: boolean,
    big?: boolean,

    rootClassName?: string,
    contentClassName?: string,
    titleClassName?: string,

    children?: any,
  }
  render () {
    const titleClassName = [
      style.title,
      this.props.const ? style.const : "",
      this.props.big ? style.bigTitle : "",
      this.props.titleClassName || "",
    ].join( " " )

    const contentClassName = [
      style.content,
      this.props.const ? style.const : "",
      this.props.big ? style.bigContent : "",
      this.props.contentClassName || "",
    ].join( " " )

    const rootClassName = [
      style.root,
      this.props.rootClassName || "",
    ].join( " " )

    return (
      <div className={rootClassName}>
        <div className={titleClassName}>{this.props.label}</div>
        <div className={contentClassName}>{this.props.children || "--"}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LabeledValue/index.jsx